// extracted by mini-css-extract-plugin
export var cartContainer = "_o2-4";
export var gray = "_o2-1";
export var itemContainer = "_o2-2";
export var itemDetails = "_o2-3";
export var strong = "_o2-0";